import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowLeft, Twitch, Trophy, Mic, Gamepad2, Youtube, ChevronRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { api } from "../lib/api";

const ICONS = { Twitch, Trophy, Mic, Gamepad2, Youtube };

export const DomainSelect = ({ onSelect, onBack }) => {
  const { t, lang } = useLang();
  const [domains, setDomains] = useState([]);

  useEffect(() => {
    api.getDomains(lang).then(setDomains).catch(() => setDomains([]));
  }, [lang]);

  return (
    <div className="flex min-h-full flex-col px-6 py-8">
      <button
        onClick={onBack}
        data-testid="domain-back"
        className="mb-6 flex w-fit items-center gap-2 text-sm font-medium text-white/50 transition-colors hover:text-white"
      >
        <ArrowLeft size={18} /> {t("back")}
      </button>

      <motion.h2
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        className="font-display text-3xl font-extrabold uppercase tracking-tight sm:text-4xl"
      >
        {t("chooseDestiny")}
      </motion.h2>
      <p className="mt-2 text-sm text-white/45">{t("chooseDestinySub")}</p>

      <div className="mt-6 grid gap-4 pb-4">
        {domains.map((d, i) => {
          const Icon = ICONS[d.icon] || Trophy;
          return (
            <motion.button
              key={d.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.07 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => onSelect(d)}
              data-testid={`domain-card-${d.id}`}
              className="group relative flex h-28 items-center overflow-hidden rounded-3xl border border-white/10 text-left"
            >
              <img
                src={d.image}
                alt={d.nom}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div
                className="absolute inset-0"
                style={{
                  background: `linear-gradient(90deg, ${d.color}dd 0%, rgba(10,10,26,0.75) 60%, rgba(10,10,26,0.55) 100%)`,
                }}
              />
              <div className="relative z-10 flex w-full items-center justify-between px-6">
                <div className="flex items-center gap-4">
                  <span
                    className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/15 backdrop-blur-md"
                    style={{ boxShadow: `0 0 20px ${d.color}80` }}
                  >
                    <Icon size={24} className="text-white" />
                  </span>
                  <div>
                    <p className="font-display text-xl font-extrabold uppercase tracking-tight text-white">
                      {d.nom}
                    </p>
                    <p className="text-xs text-white/70">{d.tagline}</p>
                  </div>
                </div>
                <ChevronRight className="text-white/70 transition-transform group-hover:translate-x-1" />
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};
